$(document).ready(async function () {
	setupProductCompareTable();
	const promises = [
		getAlertBarContent(),
		getAlertDetails(),
		getHeroBanner(),
		getHeroPromoBar(),
		getSideBySideBlock(),
		setupProductsWizard(),
	];
	await Promise.allSettled(promises);
	setupGeotargetedOaoLinks();
});

function hideAlertCookie(cookieKey) {
	var decodedCookie = decodeURIComponent(document.cookie);
	var cookie = decodedCookie.split(';');
	var status = '';

	for (var i = 0; i < cookie.length; i++) {
		if (cookie[i].trim().indexOf(cookieKey) != -1) {
			status = cookie[i].trim();
		}
	}

	if (status == cookieKey+'=false') {
		alertCookieKey = cookieKey;
		return true;
	} else {
		return false;
	}

}

function getHeroBanner(){
	return new Promise((resolve, reject) => {
		if($('.hero-banner-block-wrapper').length){
			$.ajax({
				url: ajaxurl,
				type: 'GET',
				data: {
					'action': 'get_ajax_hero',
					'pid': geot.pid
				},
				dataType: "html",
				success: function(response) {
					$('.hero-banner-block-wrapper').append(response);
					resolve();
				},
				error: function (error) {
					reject();
				}
			});
		} else {
			reject();
		}
	});
}

function getHeroPromoBar(){
	if($('.hero-promo-bar-block-wrapper').length){
		$.ajax({
			url: ajaxurl,
			type: 'GET',
			data: {
				'action': 'get_ajax_promo_bar',
				'pid': geot.pid
			},
			dataType: "html",
			success: function(response) {
				$('.hero-promo-bar-block-wrapper').append(response);
			}
		});
	}
}

function getSideBySideBlock(){
	return new Promise((resolve, reject) => {
		if($('.side-by-side-block-wrapper').length){
			const blockId = $('.side-by-side-block-wrapper')[0].id;
			$.ajax({
				url: ajaxurl,
				type: 'GET',
				data: {
					'action': 'get_ajax_side_by_side',
					'blockId' : blockId,
					'pid': geot.pid
				},
				dataType: "html",
				success: function(response) {
					$('.side-by-side-block-wrapper').append(response);
					resolve();
				},
				error: function (error) {
					reject();
				}
			});
		} else {
			reject();
		}
	});
}

function getAlertBarContent(){
	return new Promise((resolve, reject) => {
		$.ajax({
			url: ajaxurl,
			type: 'GET',
			data: {
				'action': 'get_alert_bar_content'
			},
			dataType: "json",
			success: function(response) {
				if(response && response.content){
					if(!hideAlertCookie(response.id)){
						const myAlert = document.getElementById('alertMessage')
						myAlert.addEventListener('closed.bs.alert', event => {
							document.cookie = response.id+'=false;path=/';
							$('#alertMessageWrapper').attr( "class","alert-off");
							$('.main').attr("class", 'main alertOff');
						});
						$('.main').attr("class", 'main alertOn');
						$('#alertMessageWrapper').attr( "class",'alert-on '+response.alert_type);
						$('#alertMessageIcon').addClass(response.alert_type_icon);
						$('#alertMessageContent').append( response.content);
					}
				}
				resolve();
			},
			error: function (error){
				reject();
			}
		});
	});
}

function getAlertDetails(){
	return new Promise((resolve, reject) => {
		if($('.alert-details-block-wrapper').length){
			$.ajax({
				url: ajaxurl,
				type: 'GET',
				data: {
					'action': 'get_alert_details_content'
				},
				dataType: "json",
				success: function(response) {
					if(response && response.content){
						$('.alert-details-block-row').addClass(response.alert_type);
						var alertDetailsTitle = document.createElement("h3");
						if(response.title) alertDetailsTitle.textContent = response.title;
						var alertDetailsBody = document.createElement("p");
						if(response.content) alertDetailsBody = response.content;
						$('.alert-details-block-row').append(alertDetailsTitle);
						$('.alert-details-block-row').append(alertDetailsBody);
					}
					resolve();
				},
				error: function(error) {
					reject();
				}
			});
		} else {
			reject();
		}
	});
}

function setupProductsWizard(){
	if($('.wizard-block').length){
		document.getElementById('product-wizard-want-to').addEventListener("change", async function () {
			await getWizardProducts();
			setupGeotargetedOaoLinks('.wizard-block');
		});
		document.getElementById('product-wizard-for').addEventListener("change", async function () {
			await getWizardProducts();
			setupGeotargetedOaoLinks('.wizard-block');
		});
		document.getElementById('product-wizard-residency').addEventListener("change", async function () {
			await getWizardProducts();
			setupGeotargetedOaoLinks('.wizard-block');
		});
		return getWizardProducts();
	}else{
		return Promise.reject();
	}
}

function getWizardProducts(){
	return new Promise((resolve, reject) => {
		if($('.wizard-block').length){
			var wantTo = document.getElementById('product-wizard-want-to').value;
			var forMy = document.getElementById('product-wizard-for').value;
			var residency = document.getElementById('product-wizard-residency').value;
			$.ajax({
				url: ajaxurl,
				type: 'GET',
				data: {
					'action': 'get_wizard_products',
					'purpose': wantTo,
					'for': forMy,
					'residency': residency,
				},
				dataType: "html",
				success: function(response) {
					const wizardProductList = $('.wizard-product-list');
					wizardProductList.empty();
					wizardProductList.append(response);
					resolve();
				},
				error: function (error) {
					reject();
				}
			});
		}else{
			reject();
		}
	});
}

function setupProductCompareTable(){
	if($('.product-compare-block').length){
		document.getElementById('product-compare-table-residency').addEventListener("change", function(event, value) {
			var residency = document.getElementById('product-compare-table-residency').value;
			if(residency === 'us-resident'){
				document.getElementById('product-compare-table-responsive-wrapper-us-products').classList.remove('d-none');
				document.getElementById('product-compare-table-responsive-wrapper-non-us-products').classList.add('d-none');
			} else if (residency === 'non-us-resident'){
				document.getElementById('product-compare-table-responsive-wrapper-non-us-products').classList.remove('d-none');
				document.getElementById('product-compare-table-responsive-wrapper-us-products').classList.add('d-none');
			}else{
				console.error('Product compare residency option invalid');
			}
		});
	}
}

function setupGeotargetedOaoLinks(context){
	var scope = document;
	if(context) scope = document.querySelector(context);
	var links = scope.querySelectorAll("a[href^='https://apply.amerantbank.com/openaccount'],a[href^='https://b067010509.cc-account-open.online-banking-services.com/openaccount']");
	let pidArray = [];
	links.forEach(link => {
		const urlParams = new URL(link).searchParams;
		const pid = urlParams.get('externalProductIds');
		pidArray.push(pid);
	});
	if(pidArray.length > 0){
		$.ajax({
			url: ajaxurl,
			type: 'GET',
			data: {
				'action': 'get_oao_links_mapping',
				'pids': JSON.stringify([...new Set(pidArray)])
			},
			dataType: "json",
			success: function(response) {
				links.forEach(link => {
					const linkUrl = new URL(link);
					const pid = linkUrl.searchParams.get('externalProductIds');
					for(const mapping of response){
						if(mapping.oofPid === pid){
							linkUrl.searchParams.set('externalProductIds',mapping.localizedPid);
							linkUrl.searchParams.set('externalState',mapping.externalState);
							link.href = linkUrl.origin + linkUrl.pathname + linkUrl.search;
							break;
						}
					}
				});
			},
			error: function (error) {
				console.error('error in oao mapping',error);
			}
		});
	}
}